export enum TextColor {
  primary = 'primary.contrastText',
  secondary = 'secondary.contrastText',
  black = 'black',
  white = 'white',
}

export enum BackgroundColor {
  primary = 'primary.main',
  secondary = 'secondary.main',
  black = 'black',
  white = 'white',
  transparent = 'transparent',
}
